module.exports = __webpack_public_path__ + "img/html-evolution-10.317a22f5.webp";